export default __webpack_public_path__ + "static/celibateFreezing-50ca48374c14e469025ecc9577631974.svg";